module.exports = __webpack_public_path__ + "static/media/notes.8fd541ee.svg";